import { render, staticRenderFns } from "./BannerLogos.vue?vue&type=template&id=5535032e&"
import script from "./BannerLogos.vue?vue&type=script&lang=js&"
export * from "./BannerLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports